import { useEvaluationHistory } from './evaluationHistoryAtoms';
import { useQueryClient } from '@tanstack/react-query';
import { Evaluation } from '@teetsh/app/src/containers/CarnetsDeNotes/types/carnetsDeNotes';
import { useUpdateEvaluation } from '@teetsh/app/src/containers/CarnetsDeNotes/queries/evaluations/useUpdateEvaluation';
import { cdnKeys } from '@teetsh/app/src/containers/CarnetsDeNotes/queries/keys';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';

export function useUndoEvaluation(
  carnetDeNotesId: string,
  evaluationId: string,
) {
  const { past, setPast, future, setFuture, isPastEmpty } =
    useEvaluationHistory(evaluationId);
  const updateEvaluation = useUpdateEvaluation(
    carnetDeNotesId,
    evaluationId,
    true,
  );
  const queryClient = useQueryClient();
  const { schoolyear, school } = useSchoolSchoolyear();

  return () => {
    const evaluation = queryClient.getQueryData<Evaluation>(
      cdnKeys.cdnEvaluationDetails(
        schoolyear.id,
        school.id,
        carnetDeNotesId,
        evaluationId,
      ),
    );

    if (isPastEmpty) {
      return Promise.resolve();
    }

    const lastEvaluation = past.pop() as Evaluation;
    setPast(past);

    if (evaluation) {
      setFuture([evaluation, ...future]);
    }

    return updateEvaluation.update(lastEvaluation);
  };
}
